<template>
  <div class="dataTable" @scroll="onDataScroll" ref="table_container">
    <table class="table table-striped table-bordered" >
        <thead>
        <tr>
            <th v-for="column in headings">{{column}}</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="row in data">
            <td v-for="(col,key) in row" scope="row" style="height:150px">{{col}}</td>
        </tr>
        </tbody>
    </table>
  </div>
</template>

<script>

export default {
  name: 'DataTables',
  props: {
    headings: Array,
    data: Array
    },
    mounted(){
        
    },
  methods: {
      onDataScroll({ target: { scrollTop, clientHeight, scrollHeight }}) {
          if (scrollTop + clientHeight >= scrollHeight) {
         this.$emit('loadData');
        }
        return
      },
  }
}
</script>
<style>
.dataTable{
    height: 200px;
    width: 100%;
    overflow-x:auto;
    overflow-y: auto;
}
</style>
